import React, { useState, useEffect } from "react";
import { checkEmailExists } from "../../services/userService";
import { useMsal } from "@azure/msal-react";
import { hasDevModeAccess } from "../../utils/devModeUtils";

const STORAGE_KEY = "impersonationEmail";

export default function DevTools() {
  const { instance } = useMsal();
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [activeEmail, setActiveEmail] = useState<string | null>(null);

  useEffect(() => {
    const savedEmail = localStorage.getItem(STORAGE_KEY);
    if (savedEmail) {
      setActiveEmail(savedEmail);
      setEmail(savedEmail);
    }
  }, []);

  const handleImpersonate = async () => {
    if (email) {
      try {
        const exists = await checkEmailExists(email);
        console.log(exists);

        if (exists) {
          localStorage.setItem(STORAGE_KEY, email);
          setActiveEmail(email);
          window.location.reload();
        } else {
          alert("Email não encontrado no sistema.");
        }
      } catch {
        alert("Erro ao verificar email.");
      }
    }
  };

  const handleClear = () => {
    localStorage.removeItem(STORAGE_KEY);
    setActiveEmail(null);
    setEmail("");
    window.location.reload();
  };

  const account = instance.getActiveAccount();
  if (!account || !hasDevModeAccess(account)) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        gap: "12px",
        fontFamily: "'Segoe UI', 'Roboto', sans-serif",
      }}
    >
      {/* Floating Action Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          width: "56px",
          height: "56px",
          borderRadius: "50%",
          backgroundColor: activeEmail ? "#fa8c16" : "#186bce",
          color: "white",
          border: "none",
          boxShadow: "0 4px 12px rgba(24, 107, 206, 0.3)",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "24px",
          transition: "transform 0.2s ease, background-color 0.2s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        title="Dev Tools"
      >
        {activeEmail ? "⚠" : "🔧"}
      </button>

      {/* Main Panel */}
      {isOpen && (
        <div
          style={{
            position: "absolute",
            bottom: "70px",
            right: "0",
            width: "300px",
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "12px",
            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
            border: "1px solid #e5e7eb",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "16px",
            }}
          >
            <h3
              style={{
                margin: 0,
                fontSize: "16px",
                fontWeight: 600,
                color: "#186bce",
              }}
            >
              Dev Tools
            </h3>
            {activeEmail && (
              <span
                style={{
                  fontSize: "10px",
                  backgroundColor: "#fff2e5",
                  color: "#fa8c16",
                  padding: "4px 8px",
                  borderRadius: "12px",
                  fontWeight: "bold",
                  border: "1px solid #ffd591",
                }}
              >
                ACTIVE
              </span>
            )}
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            }}
          >
            <div>
              <label
                style={{
                  display: "block",
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "#6f6f76",
                  marginBottom: "6px",
                }}
              >
                Impersonate User (Email):
              </label>
              <input
                type="email"
                placeholder="user@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "8px",
                  border: "1px solid #e0e0e0",
                  fontSize: "14px",
                  outline: "none",
                  boxSizing: "border-box",
                  color: "#333",
                }}
                onFocus={(e) => (e.currentTarget.style.borderColor = "#186bce")}
                onBlur={(e) => (e.currentTarget.style.borderColor = "#e0e0e0")}
              />
            </div>

            {activeEmail && (
              <div
                style={{
                  fontSize: "12px",
                  color: "#666",
                  backgroundColor: "#f5f5f5",
                  padding: "8px",
                  borderRadius: "6px",
                  wordBreak: "break-all",
                }}
              >
                Currently impersonating:
                <div
                  style={{ fontWeight: 600, color: "#333", marginTop: "2px" }}
                >
                  {activeEmail}
                </div>
              </div>
            )}

            <div style={{ display: "flex", gap: "10px", marginTop: "8px" }}>
              <button
                onClick={handleImpersonate}
                style={{
                  flex: 1,
                  padding: "10px",
                  backgroundColor: "#186bce",
                  color: "white",
                  border: "none",
                  borderRadius: "9999px",
                  fontSize: "14px",
                  fontWeight: 600,
                  cursor: "pointer",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#145db5")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "#186bce")
                }
              >
                Apply
              </button>
              <button
                onClick={handleClear}
                style={{
                  flex: 1,
                  padding: "10px",
                  backgroundColor: "transparent",
                  color: "#6f6f76",
                  border: "1px solid #e0e0e0",
                  borderRadius: "9999px",
                  fontSize: "14px",
                  fontWeight: 600,
                  cursor: "pointer",
                  transition: "all 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#fff1f0";
                  e.currentTarget.style.color = "#ff4d4f";
                  e.currentTarget.style.borderColor = "#ff4d4f";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.color = "#6f6f76";
                  e.currentTarget.style.borderColor = "#e0e0e0";
                }}
              >
                Clear
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
